import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import DownloadButton from "./DownloadButton";
import GooglePlayButton from "./GooglePlayButton";

interface HeaderProps {
  onHowClick?: () => void;
  onPricingClick?: () => void;
  onJoinClick?: () => void;
}

const Header: React.FC<HeaderProps> = ({ onHowClick, onPricingClick, onJoinClick }) => {
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleLogoClick = (e: React.MouseEvent) => {
    if (location.pathname === "/") {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <header
      className={`w-full flex items-center justify-between px-6 py-3 sticky top-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-[#000000] border-b border-white/10" : "bg-transparent"
      }`}
    >
      <div className="flex items-center h-16">
        <Link to="/" onClick={handleLogoClick} className="flex items-center h-full">
          <img src="/ammopantryai.svg" alt="AmmoPantryAI Logo" className="h-16 w-36 object-contain block" style={{ filter: 'invert(1)' }} />
        </Link>
      </div>
      <div className="hidden md:flex items-center gap-4 pr-12">
        <DownloadButton variant="white" />
        <GooglePlayButton />
      </div>
    </header>
  );
};

export default Header;
